import React from "react";
import { connect } from "react-redux";
import DataSheetRow from "./DataSheetRow";
import SupplierRemarks from "./SupplierRemarks";
import Select from "react-select";

class PClothFilterDS extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tertiaryTreatmentUnits: "",
      model: "",
      minFlow: null,
      instantaneousBackwasFlowRate: null,
      backwashFreq: null,
      backwashDuration: null,
      instantaneousDesludgeFlow: null,
      desludgeFrequency: null,
      desludgeDuration: null,
      flashMixingChambers: null,
      flashMixingHRT: null,
      flashMixingVolume: null,
      flocculationChambers: null,
      flocculationHRT: null,
      flocculationVolume: null,
      backwashMaxReturn: null,
      backwashAttenuation: null,
      TSSAverageConc: null,
      totalPAnnualMeanConc: null,
      hazardousAreaClassification: "",
      siteLocation: "",
    };
  }

  render() {
    return (
      <>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="col-1">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={this.onFormSubmit}
                >
                  Save
                </button>
              </div>
              <div className="col-10">
                <h2 id="pageModalLabel" style={{ fontWeight: "bold" }}>
                  P-Schemes Cloth Filter Data Sheet
                </h2>
              </div>
              <div className="col-1">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  data-keyboard="true"
                  aria-label="Close"
                ></button>
              </div>
            </div>
            <div className="modal-body">
              <div>
                <form>
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <h3>ASSET INFORMATION</h3>
                  </div>
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <h3>Project: {this.props.project.text}</h3>
                  </div>
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div style={{ width: "40%" }}>
                      <Select
                        classNamePrefix={"form-control"}
                        placeholder="Please select an asset"
                        //value={"selectedOption"}
                        //   onChange={this.handleBrowseFilterChange}
                        //   options={[
                        //     { value: "All Classes", label: "All Classes" },
                        //   ].concat(
                        //     this.props.categories.map((category) => {
                        //       return { value: category, label: category };
                        //     })
                        //   )}
                        //getOptionLabel={option => option.text}
                        //getOptionValue={option => option.text}
                        // className="form-control"
                      />
                    </div>
                  </div>
                  <hr
                    style={{
                      color: "#6d7a80",
                      backgroundColor: "#6d7a80",
                      height: 2,
                      borderColor: "#6d7a80",
                    }}
                  ></hr>
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <h3>OPERATING / DESIGN DATA</h3>
                  </div>
                  <DataSheetRow
                    description="Number of Tertiary treatment units"
                    inputId="tertiaryTreatmentUnits"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="Working"
                  />
                  <DataSheetRow
                    description="Model"
                    inputId="model"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="Vendor to confirm"
                  />
                  <DataSheetRow
                    description="Minimum flow"
                    inputId="minFlow"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="l/s (inc. return) Vendor To Confirm if any requirements for min flow"
                  />
                  <DataSheetRow
                    description="Average Flow"
                    inputId="averageFlow"
                    inputType="calc"
                    inputValue=""
                    comment="l/s (inc. return)"
                  />
                  <DataSheetRow
                    description="Max feed flow"
                    inputId="maxFeedFlow"
                    inputType="calc"
                    inputValue=""
                    comment="l/s (inc. return)"
                  />
                  <DataSheetRow
                    description="Average solids loading ( excluding chemical )"
                    inputId="averageSolidsLoadingExc"
                    inputType="calc"
                    inputValue=""
                    comment="kg/h"
                  />
                  <DataSheetRow
                    description="Peak solids loading ( excluding chemical )"
                    inputId="peakSolidsLoadingExc"
                    inputType="calc"
                    inputValue=""
                    comment="kg/h"
                  />
                  <DataSheetRow
                    description="Average solids loading (including chemical )"
                    inputId="averageSolidsLoadingInc"
                    inputType="calc"
                    inputValue=""
                    comment="kg/h"
                  />
                  <DataSheetRow
                    description="Peak solids loading ( including chemical )"
                    inputId="peakSolidsLoadingInc"
                    inputType="calc"
                    inputValue=""
                    comment="kg/h"
                  />
                  <DataSheetRow
                    description="Instantaneous backwash flow rate"
                    inputId="instantaneousBackwasFlowRate"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="l/s Backwash inhibit Signal from others"
                  />
                  <DataSheetRow
                    description="Backwash frequency"
                    inputId="backwashFreq"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="No./h (@Peak Load) (minimum one a day)"
                  />
                  <DataSheetRow
                    description="Backwash duration"
                    inputId="backwashDuration"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="seconds"
                  />
                  <DataSheetRow
                    description="Instantaneous de-sludge flow"
                    inputId="instantaneousDesludgeFlow"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="l/s"
                  />
                  <DataSheetRow
                    description="De-sludge frequency"
                    inputId="desludgeFrequency"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="No./h"
                  />
                  <DataSheetRow
                    description="Desludge duration"
                    inputId="desludgeDuration"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="seconds"
                  />
                  <br />
                  <DataSheetRow
                    description="Number of Flash mixing chambers"
                    inputId="flashMixingChambers"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="Working"
                  />
                  <DataSheetRow
                    description="Flash mixing HRT"
                    inputId="flashMixingHRT"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="min Vendor to guarantee mixing efficiency"
                  />
                  <DataSheetRow
                    description="Flash mixing volume"
                    inputId="flashMixingVolume"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="m3"
                  />
                  <br />
                  <DataSheetRow
                    description="Number of Flocculation chambers"
                    inputId="flocculationChambers"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="Working"
                  />
                  <DataSheetRow
                    description="Flocculation HRT "
                    inputId="flocculationHRT"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="min Vendor to guarantee mixing efficiency"
                  />
                  <DataSheetRow
                    description="Flocculation volume per chamber"
                    inputId="flocculationVolume"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="m3"
                  />
                  <br />
                  <DataSheetRow
                    description="Backwash maximum return rate"
                    inputId="backwashMaxReturn"
                    inputType="manual"
                    inputValue=""
                    comment="l/s"
                  />
                  <DataSheetRow
                    description="Backwash attenuation tank"
                    inputId="backwashAttenuation"
                    inputType="vtc"
                    inputValue="Vendor To Confirm"
                    comment="m3"
                  />
                  <hr
                    style={{
                      color: "#6d7a80",
                      backgroundColor: "#6d7a80",
                      height: 2,
                      borderColor: "#6d7a80",
                    }}
                  ></hr>
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <h3>EFFLUENT REQUIREMENTS</h3>
                  </div>
                  <DataSheetRow
                    description="TSS average concentration"
                    inputId="TSSAverageConc"
                    inputType="manual"
                    inputValue=""
                    comment="mg/l Spot samples (10 for total P > 0.3 mg/l, 5 for  total P<0.3 mg/l )"
                  />
                  <DataSheetRow
                    description="Total-P Annual mean concentration"
                    inputId="totalPAnnualMeanConc"
                    inputType="calc"
                    inputValue=""
                    comment="mg/l Spot samples (for information)"
                  />
                  <DataSheetRow
                    description="Iron (95 percentile)"
                    inputId="iron95Percentile"
                    inputType="calc"
                    inputValue=""
                    comment="mg/l Spot samples (for information)"
                  />
                  <hr
                    style={{
                      color: "#6d7a80",
                      backgroundColor: "#6d7a80",
                      height: 2,
                      borderColor: "#6d7a80",
                    }}
                  ></hr>
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <h3>ENVIRONMENTAL CONDITIONS</h3>
                  </div>
                  <DataSheetRow
                    description="Hazardous Area Classification"
                    inputId="hazardousAreaClassification"
                    inputType="manual"
                    inputValue=""
                    comment=""
                  />
                  <DataSheetRow
                    description="Site location"
                    inputId="siteLocation"
                    inputType="manual"
                    inputValue=""
                    comment="Inland/Coastal"
                  />
                  <DataSheetRow
                    description="Max wastewater temperature"
                    inputId="maxWastewaterTemp"
                    inputType="calc"
                    inputValue="30"
                    comment="degrees C"
                  />
                  <DataSheetRow
                    description="Min wastewater temperature"
                    inputId="minWastewaterTemp"
                    inputType="calc"
                    inputValue="5"
                    comment="degrees C"
                  />
                  <hr
                    style={{
                      color: "#6d7a80",
                      backgroundColor: "#6d7a80",
                      height: 2,
                      borderColor: "#6d7a80",
                    }}
                  ></hr>
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <h3>REMARKS AND INSTRUCTIONS TO SUPPLIER</h3>
                  </div>
                  <SupplierRemarks number="1" />
                  <SupplierRemarks number="2" />
                  <SupplierRemarks number="3" />
                  <SupplierRemarks number="4" />
                  <SupplierRemarks number="5" />
                  <SupplierRemarks number="6" />
                  <SupplierRemarks number="7" />
                  <SupplierRemarks number="8" />
                  <hr
                    style={{
                      color: "#6d7a80",
                      backgroundColor: "#6d7a80",
                      height: 2,
                      borderColor: "#6d7a80",
                    }}
                  ></hr>
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <h3>HANDOVER TESTING REQUIREMENTS</h3>
                  </div>
                  <div>
                    <table
                      className="table table-responsive"
                      style={{ margin: "auto", width: "820px" }}
                    >
                      <thead>
                        <tr>
                          <th>Parameter</th>
                          <th>Min test period (days)</th>
                          <th>Type of sample</th>
                          <th>Number of spot samples</th>
                          <th>Statistical basis</th>
                          <th>Pass Criteria</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>TSS</td>
                          <td>10</td>
                          <td>Spot</td>
                          <td>20</td>
                          <td>Average</td>
                          <td>{this.state.TSSAverageConc}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect()(PClothFilterDS);
